import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
// not like to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init

const fallbackLng = ['en']; 
const availableLanguages = ['en', 'en-US', 'en-GB', 'es', 'de', 'fr'];

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: fallbackLng,
    debug: false,
    whitelist: availableLanguages,
    // resources: {
    //   en: {
    //     translation: {
    //       "key": "{{value, price, EUR}}"
    //     }
    //   }
    // },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
        loadPath: () => {
        // check the domain
        //const host = window.location.host;
        //return (host === 'production.ltd' ? '/static/app':'') + '/static/app/static(locales/{ { lng} } /{ { ns} } .json';
        return './locales/{{lng}}/{{ns}}.json';
        }
    }
  });

  i18n.addResourceBundle('de', 'currencysymbol', {key: 'EUR'});
  i18n.addResourceBundle('en', 'currencysymbol', {key: 'USD'});
  i18n.addResourceBundle('en-GB', 'currencysymbol', {key: 'GBP'});
  i18n.addResourceBundle('en-US', 'currencysymbol', {key: 'USD'});
  i18n.addResourceBundle('es', 'currencysymbol', {key: 'EUR'});
  i18n.addResourceBundle('fr', 'currencysymbol', {key: 'EUR'});

export default i18n;